/**
 * Shared time period constants for consistent filtering across all pages
 */

// Time period presets - used across TechStack, Sankey, Classifications, etc.
export const TIME_PERIODS = [
  { value: 'last-30-days', label: '30D', days: 30 },
  { value: 'last-90-days', label: '90D', days: 90 },
  { value: 'last-6-months', label: '6M', days: 182 },
  { value: 'last-year', label: '1Y', days: 365 },
  { value: 'last-2-years', label: '2Y', days: 730 },
  { value: 'last-3-years', label: '3Y', days: 1095 },
  { value: 'last-5-years', label: '5Y', days: 1825, default: true },
  { value: 'ytd', label: 'YTD', days: null }, // Calculated dynamically
  { value: 'all-time', label: 'All', days: null }
];

// Default period
export const DEFAULT_PERIOD = 'last-5-years';

/**
 * Calculate date range from a period value
 * @param {string} period - Period value (e.g., 'last-5-years', 'ytd')
 * @returns {{ startDate: Date, endDate: Date }}
 */
export function calculateDateRange(period) {
  const endDate = new Date();
  let startDate = new Date();

  const periodConfig = TIME_PERIODS.find(p => p.value === period);

  if (period === 'ytd') {
    startDate = new Date(endDate.getFullYear(), 0, 1); // Jan 1 of current year
  } else if (period === 'all-time') {
    startDate = new Date('2000-01-01');
  } else if (periodConfig?.days) {
    startDate.setDate(startDate.getDate() - periodConfig.days);
  } else {
    // Default to 5 years
    startDate.setFullYear(startDate.getFullYear() - 5);
  }

  return { startDate, endDate };
}

/**
 * Format date to YYYY-MM-DD string
 * @param {Date} date
 * @returns {string}
 */
export function formatDate(date) {
  return date.toISOString().split('T')[0];
}

/**
 * Get date range as formatted strings
 * @param {string} period
 * @returns {{ startDate: string, endDate: string }}
 */
export function getDateRangeStrings(period) {
  const { startDate, endDate } = calculateDateRange(period);
  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
}
